import Image from 'next/image';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import CommunityPostCreated from '@/components/icons/CommunityPostCreated';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import SubHeading from '@/components/SubHeading';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import InsectImage from '@/images/ask-question/insect.webp';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
interface Props {
  postSlug: string;
  readMoreHref: string;
}
const SuccessPopup = ({
  postSlug,
  readMoreHref
}: Props) => {
  const {
    t
  } = useTranslation('askQuestion');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const handleClick = () => {
    trackCustomEvent(CustomEventTypes.ASK_HELP_READ_MORE_CLICKED);
  };
  const handleSeePost = () => {
    trackCustomEvent(CustomEventTypes.ASK_HELP_SEE_POST_CLICKED);
  };
  return <div className="bg-white fixed flex flex-col h-screen items-center left-0 p-4 top-0 w-screen z-50" data-sentry-component="SuccessPopup" data-sentry-source-file="SuccessPopup.tsx">
      <CommunityPostCreated className="mt-6 w-56" data-sentry-element="CommunityPostCreated" data-sentry-source-file="SuccessPopup.tsx" />
      <SubHeading className="max-w-xs mt-6 text-center" data-sentry-element="SubHeading" data-sentry-source-file="SuccessPopup.tsx">
        {t('soln_soon')}
      </SubHeading>
      <div className="bg-primary-10 flex items-center justify-between mt-16 p-4 rounded-lg w-full">
        <div className="max-w-[212px]">
          <Paragraph className="font-nato-semibold mb-4" variant={VARIANT.MEDIUM} data-sentry-element="Paragraph" data-sentry-source-file="SuccessPopup.tsx">
            {t('most_happening')}
          </Paragraph>
          <Link className="bg-primary-100 font-nato-semibold inline-block px-4 py-3 rounded-lg text-sm text-white" href={readMoreHref} onClick={handleClick} data-sentry-element="Link" data-sentry-source-file="SuccessPopup.tsx">
            {t('cropProblems:read_more')}
          </Link>
        </div>
        <Image alt="Insect image" height={80} src={InsectImage} data-sentry-element="Image" data-sentry-source-file="SuccessPopup.tsx" />
      </div>
      <Link className="bg-primary-100 bottom-4 fixed font-nato-semibold left-4 p-4 right-4 rounded-lg text-center text-white" href={`/community/post/${postSlug}`} onClick={handleSeePost} data-sentry-element="Link" data-sentry-source-file="SuccessPopup.tsx">
        {t('see_post')}
      </Link>
    </div>;
};
export default SuccessPopup;